import { Formulation } from '@app:types';
import { Flex, Progress, StackProps, Tag, Text, VStack } from '@chakra-ui/react';

export function FormulationContainer({ formulation, ...props }: { formulation: Formulation } & StackProps) {
  const entries = Object.entries(formulation);

  if (entries.length === 0) {
    return (
      <VStack {...props} spacing={4}>
        <Tag alignSelf={'flex-start'}>No formulation available.</Tag>
      </VStack>
    );
  }

  return (
    <VStack {...props} spacing={4}>
      {entries.map(([materialId, quantity]) => {
        let percentage: number = quantity.amount * 100;
        return (
          <Flex key={materialId} w='100%' gap={5} alignItems={'center'}>
            <Text flex={2}>{quantity.label}</Text>
            <Progress flex={3} value={percentage} />
            <Text flex={2}>(~{percentage.toFixed(2)}%)</Text>
          </Flex>
        );
      })}
    </VStack>
  );
}
